import Footer from '$components/Footer'
import { StyledLayout } from '$globalStyledComponents/Layout'
import { Typography } from 'antd'
import { useTranslation } from 'react-i18next'
import TopKpiCard from './TopKpiCard'
import MaterialMapper from './MaterialMapper'

const { Content } = StyledLayout
const { Title } = Typography

const Operatormaterials = () => {
  const { t } = useTranslation()

  return (
    <StyledLayout className="layout">
      <Content>
        <Title level={1} style={{ margin: '50px 0' }}>
          {t('operator_additive_materials.header')}
        </Title>

        <TopKpiCard />

        <div className="contentcard" style={{ marginTop: '24px' }}>
          <MaterialMapper />
        </div>
      </Content>
      <Footer />
    </StyledLayout>
  )
}

export default Operatormaterials
